export const AMBER_3 = '#FFE58F';
export const AMBER_6 = '#FAAD14';
export const GREY = '#BFBFBF';
export const GREEN_3 = '#B7EB8F';
export const GREEN_6 = '#52C41A';
export const RED = '#F5222D';
export const RED_3 = '#FFA39E';
export const RED_6 = '#F5222D';
export const BLUE = '#1890FF';
